import React from 'react';
import 'twin.macro';

import Facebook from '~components/Svg/Facebook';
import Instagram from '~components/Svg/Instagram';
import Twitter from '~components/Svg/Twitter';

interface SocialCardProps {
  site: 'facebook' | 'instagram' | 'twitter';
}

const SocialCard: React.FC<SocialCardProps> = ({ site, children }) => {
  const icons = {
    facebook: <Facebook tw="h-12 w-auto" />,
    instagram: <Instagram tw="h-12 w-auto" />,
    twitter: <Twitter tw="h-12 w-auto" />
  };

  const colors = {
    facebook: '#4267B2',
    instagram: '#EF3179',
    twitter: '#1DA1F2'
  };

  return (
    <div tw="flex flex-col">
      <div
        tw="rounded-t-xl text-white flex justify-center py-2 px-3"
        style={{ backgroundColor: colors[site] }}
      >
        {icons[site]}
      </div>
      <div tw="rounded-b-xl text-gray-800 bg-gray-100 py-2 px-3">{children}</div>
    </div>
  );
};

export default SocialCard;
